import axios from 'axios';

/*
const isProduction = process.env.NODE_ENV === 'production';
const baseURL = isProduction
    ? 'https://sappe.jcda.nl/wp-json/junction/v1'
    : 'https://sappe.lndo.site/wp-json/junction/v1';
*/

const baseURL = '/wp-json/junction/v1';

const api = axios.create({
    baseURL: baseURL,
    headers: {
        'X-WP-Nonce': wpApiSettings.nonce,
        'Content-Type': 'application/json'
    }
});

export default api;